import React from "react";

import ClubhouseFilters from "./components/ClubhouseFilters";
import ClubhouseTable from "./components/ClubhouseTable";
import { IndexProvider } from "./contexts/Index";

import { useAppSelector } from "../../../../hooks/reduxHooks";
import { AUTH_LEVELS } from "../../../../lib/globals";

const ClubhouseIndex = (): React.JSX.Element => {
    const { user } = useAppSelector(state => state.auth);

    return (
        <IndexProvider>
            {user && AUTH_LEVELS.leaguemanagement.includes(user.userLevel) && (
                <ClubhouseFilters />
            )}

            <ClubhouseTable />
        </IndexProvider>
    );
};

export default ClubhouseIndex;
